import ChatList from './ChatList';
import ChatInput from './ChatInput';
import { ChatFooter } from './Footer';
import ChatWelcome from './ChatWelcome';
import styles from './styles.module.scss';
import { useChatInput } from 'hooks/useChatInput';
import { useAppContext } from 'context/AppContext';
import { useStyleContext } from 'context/StyleContext';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import { LoaderGlobal } from 'packages/radiant-react/loading-indicator';

function Loader() {
  return (
    <Horizontal className={styles['container-content-loader']}>
      <LoaderGlobal className="loader-global-home">
        <></>
      </LoaderGlobal>
    </Horizontal>
  );
}

function Chat() {
  const { chatMessages } = useAppContext();
  const { styleStateKey } = useStyleContext();
  const isUserInfoPresent = styleStateKey !== '';
  const isChatMessagesEmpty = chatMessages.length === 0;
  const {
    handleTextareaInput,
    handleEnterKeyPress,
    handleArrowUpClick,
    userInput,
    updateUserInput,
  } = useChatInput();

  return (
    <Vertical className={styles['main-container']}>
      <Vertical className={styles['container']}>
        {isChatMessagesEmpty ? <ChatWelcome updateUserInput={updateUserInput} /> : <ChatList />}
        <Vertical className={styles['chat-input-container']}>
          <ChatInput
            handleTextareaInput={handleTextareaInput}
            handleEnterKeyPress={handleEnterKeyPress}
            handleArrowUpClick={handleArrowUpClick}
            userInput={userInput}
          />
        </Vertical>
        <ChatFooter />
      </Vertical>
      {!isUserInfoPresent && <Loader />}
    </Vertical>
  );
}

export default Chat;
